import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setLanguage } from "../../redux/slices/languageSlice";
import translations from "../i18n/translations";

const interpolate = (template, vars) =>
  vars ? template.replace(/{{\s*(\w+)\s*}}/g, (match, key) => (key in vars ? String(vars[key]) : match)) : template;

const resolveKey = (dict, key) => key.split(".").reduce((value, segment) => value?.[segment], dict);

export default function useTranslation() {
  const language = useSelector((state) => state.language.language);
  const dispatch = useDispatch();

  const t = useCallback(
    (key, vars) => {
      const value = resolveKey(translations[language], key) ?? resolveKey(translations.en, key);

      if (value === undefined) {
        return key;
      }

      return typeof value === "string" ? interpolate(value, vars) : value;
    },
    [language],
  );

  const changeLanguage = useCallback(
    (nextLanguage) => {
      dispatch(setLanguage(nextLanguage));
    },
    [dispatch],
  );

  return { t, language, setLanguage: changeLanguage };
}
